module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_nestle-61dc93f9c09aeaa81a038dc0e3cc8f52.png";